import { normalizeLocale } from './normalize'

export function createLocaleStorage({ storage, policy }) {
  function readRaw() {
    return storage.getItem(policy.key)
  }

  function read(availableLocales) {
    return (
      readPrimary(availableLocales) ||
      (policy.fallbackKey ? normalizeLocale(storage.getItem(policy.fallbackKey), availableLocales) : null)
    )
  }

  function readPrimary(availableLocales) {
    return normalizeLocale(policy.deserialize(readRaw()), availableLocales)
  }

  function write(value) {
    const serialized = policy.serialize(value)
    if (!serialized) {
      return null
    }
    storage.setItem(policy.key, serialized)
    if (policy.fallbackKey) {
      storage.setItem(policy.fallbackKey, policy.deserialize(serialized))
    }
    return read()
  }

  return { readRaw, read, readPrimary, write }
}
